<template lang="pug">
    .md-content
        PmBreadcrumbs(:view="lenguageSelected.breadcrumb", :section="section", :lang="lenguage")
        PmBanner(:name="lenguageNavSelected.title", :image="banner")
        PmContentBox(:content="lenguageNavSelected.box")
        .container
            .row.careers
                .col-md-9.products-template-content.no-margin-bottom
                    .contact-content
                        p   {{ lenguageSelected.content1 }}
                    form#contact-form(action="/contact/send-email")
                        .contact-content-list
                            .contact-content-list-item(v-for="item in lenguageSelected.content2")
                                input(:name="item.name", type="checkbox", :value="item.title", v-model="form.form_departments", @change="validateInputs")
                                span    {{ item.title }}
                        span.error(:style="error.form_departments? 'opacity: 1' : 'opacity: 0'") {{lenguageSelected.error}}
                        p.contact-content-list-last(v-for="item in lenguageSelected.content3") {{ item }}
                        .contact-content-form
                            .row
                                .col-md-12
                                    select(name="country", v-model="form.form_country", @change="validateInputs")
                                        option(value="", style="display:none") {{lenguageSelected.content6.none}}
                                        option(v-for="item in lenguageSelected.content6.countries", :value="item") {{ item }}
                                    span.error.error-country(:style="error.form_country? 'opacity: 1' : 'opacity: 0'") {{lenguageSelected.error2}}
                                .col-md-6(v-if="window.width > 900")
                                    slot(v-for="(item, index) in lenguageSelected.content4")
                                        input(:name="item.name",type="text", :placeholder="item.placeholder", v-model="form.data[index]", @keyup="validateInputs")
                                        span.error(:style="error.data[index]? 'opacity: 1' : 'opacity: 0'") {{lenguageSelected.error2}}
                                .col-md-6(v-if="window.width > 900")
                                    slot(v-for="(item, index) in lenguageSelected.content5")
                                        input(:name="item.name",type="text", :placeholder="item.placeholder", v-model="form.data2[index]", @keyup="validateInputs")
                                        span.error(:style="error.data2[index]? 'opacity: 1' : 'opacity: 0'")(:class="item.class") {{lenguageSelected.error2}}

                                .col-md-12(v-for="(item, index) in lenguageSelected.contentmovil", v-if="window.width < 900")
                                    slot
                                        input(:name="item.name",type="text", :placeholder="item.placeholder", v-model="form.data2[index]", @keyup="validateInputs")
                                        span.error(:style="error.data2[index]? 'opacity: 1' : 'opacity: 0'")(:class="item.class") {{lenguageSelected.error2}}
                                .col-md-12
                                    textarea(:name="lenguageSelected.content7.name", :placeholder="lenguageSelected.content7.placeholder", v-model="form.message", @keyup="validateInputs")
                                    span.error.error-message(:style="error.message? 'opacity: 1' : 'opacity: 0'") {{lenguageSelected.error2}}
                                .col-md-12
                                    // VueRecaptcha(sitekey="6LfDsaoUAAAAAHKuxUMaABvagX1wYFWSiPWWQK5i", :loadRecaptchaScript="true")
                            .button-toggle
                                button.button-submit(type="submit", @click.prevent="sendData", v-if="sendState == 'normal'") {{lenguageSelected.content8}}
                                button.btn-inactive(@click.prevent="", v-if="sendState == 'loading'")
                                    i.fas.fa-circle-notch
                            .message-send-finish(v-if="sendState == 'finish'")
                                |   {{lenguageSelected.contactText}}
                PmContactTable(:lang="lenguage")
</template>

<script>
import PmBreadcrumbs from '@components/atoms/PmBreadCrumbs.vue'
import PmContactTable from '@components/molecules/PmContactTable.vue'
import PmBanner from '@components/atoms/PmBanner.vue'
import PmContentBox from '@components/atoms/PmContentBox.vue'
import PmSidebar from '@components/atoms/PmSidebar.vue'
import VueRecaptcha from 'vue-recaptcha';

import contactBanner from '@img/contact/Banner_CONTACT.jpg'

import axios from 'axios'

import { isEmpty } from 'lodash'

export default {
    props: ["lang"],
    created: function(){
        this.$data.lenguage = this.lang;
        window.addEventListener('resize', this.handleResize)
        this.handleResize();
    },
    components: {
        PmBreadcrumbs, PmBanner, PmContentBox, PmSidebar, VueRecaptcha, PmContactTable
    },
    mounted: function(){
        this.$data.section = this.$route.name;
        let to = this.moveToDown
        ? this.$refs.description.offsetTop - 60
        : 0

    window.scroll({
        top: to,
        left: 0,
        behavior: 'smooth'
    })

    this.moveToDown = !this.moveToDown
    },

    methods: {
        sendData: function(){
            this.$data.isactivated = true
            var validate = this.validateData()
            if(validate){
                this.$data.sendState = 'loading'

                var departments = this.$data.form.form_departments; //name
                var departmentsString = ''
                departments.map(val => departmentsString += '<li>'+val+'</li>')

                var country = this.$data.form.form_country;

                var firstName = this.$data.form.data[0]; //name
                var street = this.$data.form.data[1]; //street
                var city = this.$data.form.data[2]; //city
                var email = this.$data.form.data[3]; //email

                var lastName = this.$data.form.data2[0];
                var zip = this.$data.form.data2[1];
                var phoneNumber = this.$data.form.data2[2];

                var message = this.$data.form.message;

                var formBody = `    <!DOCTYPE html>
                    <html style="background-color: #EEE;">
                    <head>
                        <meta charset="utf-8">
                        <title>ATP - CONTACT</title>
                    </head>
                    <body style="width: 600px; padding: 24px; margin: 0 auto; background-color: #FFF;">
                        <table style="border-collapse: collapse; table-layout: fixed; width: 600px; margin: 0 auto; color: #545454; font-family: sans-serif; font-size: 14px;">
                            <tbody>
                                <tr>
                                    <td>
                                        <table style="border-collapse: collapse; table-layout: fixed; width: 100%;">
                                            <tbody>
                                                <tr>
                                                    <td>
                                                        <img height="100" style="vertical-align: top;" src="https://atpsites.com/build/logo.png" alt="ATP LOGO">
                                                    </td>
                                                </tr>
                                                <tr><td style="height: 24px;"></td></tr>
                                                <tr>
                                                    <td style="font-size: 16px;">
                                                        This email was sent from the contact section of the web of ATP
                                                    </td>
                                                </tr>
                                                </tr>
                                                <tr><td style="height: 6px;"></td></tr>
                                            </tbody>
                                        </table>
                                        <table style="border-collapse: collapse; table-layout: fixed; width: 100%;">
                                            <tbody>
                                                <tr>
                                                    <td colspan="2" style="width: 389px; padding: 10px; border: 1px solid #EEE;">First Name:  ${firstName}</td>
                                                </tr>
                                                <tr>
                                                    <td colspan="2" style="width: 389px; padding: 10px; border: 1px solid #EEE;">Last Name:  ${lastName}</td>
                                                </tr>
                                                <tr>
                                                    <td colspan="2" style="width: 389px; padding: 10px; border: 1px solid #EEE;">Street Adress:  ${street}</td>
                                                </tr>
                                                <tr>
                                                    <td colspan="2" style="width: 389px; padding: 10px; border: 1px solid #EEE;">ZIP Code:  ${zip}</td>
                                                </tr>
                                                <tr>
                                                    <td colspan="2" style="width: 389px; padding: 10px; border: 1px solid #EEE;">City, State:  ${city}</td>
                                                </tr>
                                                <tr>
                                                    <td colspan="2" style="width: 389px; padding: 10px; border: 1px solid #EEE;">Country:  ${country}</td>
                                                </tr>
                                                <tr>
                                                    <td colspan="2" style="width: 389px; padding: 10px; border: 1px solid #EEE;">Email:  ${email}</td>
                                                </tr>
                                                <tr>
                                                    <td colspan="2" style="width: 389px; padding: 10px; border: 1px solid #EEE;">Phone:  ${phoneNumber}</td>
                                                </tr>
                                                <tr>
                                                    <td style="width: 150px; padding: 10px; border: 1px solid #EEE;">Departments:  </td>
                                                    <td style="width: 150px; padding: 10px; border: 1px solid #EEE;">
                                                        <ul>
                                                            ${departmentsString}
                                                        <ul>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td colspan="2" style="width: 389px; padding: 10px; border: 1px solid #EEE;">Message:  ${message}</td>
                                                </tr>
                                                <tr><td style="height: 24px;" colspan="2"></td></tr>
                                            </tbody>
                                        </table>
                                        <table style="border-collapse: collapse; table-layout: fixed; width: 100%;">
                                            <tbody>
                                                <tr><td style="height: 24px;"></td></tr>
                                                <tr>
                                                    <td style="font-size: 10px; text-align: center;">
                                                        ATP Sites 2018 | Powered by Massive Dynamics Peru
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </body>
                    </html>
            `

                const obj = {
                    html: formBody,
                    to: email,
                    country
                }

                axios.post('/api/action/email-contact', obj)
                this.$data.sendState = 'finish'
            }
        },
        handleResize() {
            this.$data.window.width = window.innerWidth;
            this.$data.window.height = window.innerHeight;
        },
        validateInputs: function(){
            if(this.$data.isactivated){
                this.validateData();
            }
        },
        validateData: function(){
            var validate = true
            if(this.$data.form.form_departments.length == 0){
                this.$data.error.form_departments = true
                validate = false
            }else{
                this.$data.error.form_departments = false
            }

            if(isEmpty(this.$data.form.form_country)){
                this.$data.error.form_country = true
                validate = false
            }else{
                this.$data.error.form_country = false
            }

            if(isEmpty(this.$data.form.data[0])){
                this.$data.error.data[0] = true
                validate = false
            }else{
                this.$data.error.data[0] = false
            }

            if(isEmpty(this.$data.form.data[1])){
                this.$data.error.data[1] = true
                validate = false
            }else{
                this.$data.error.data[1] = false
            }

            if(isEmpty(this.$data.form.data[2])){
                this.$data.error.data[2] = true
                validate = false
            }else{
                this.$data.error.data[2] = false
            }

            if(isEmpty(this.$data.form.data[3])){
                this.$data.error.data[3] = true
                validate = false
            }else{
                this.$data.error.data[3] = false
            }

            if(isEmpty(this.$data.form.data2[0])){
                this.$data.error.data2[0] = true
                validate = false
            }else{
                this.$data.error.data2[0] = false
            }

            if(isEmpty(this.$data.form.data2[1])){
                this.$data.error.data2[1] = true
                validate = false
            }else{
                this.$data.error.data2[1] = false
            }

            if(isEmpty(this.$data.form.data2[2])){
                this.$data.error.data2[2] = true
                validate = false
            }else{
                this.$data.error.data2[2] = false
            }

            if(isEmpty(this.$data.form.message)){
                this.$data.error.message = true
                validate = false
            }else{
                this.$data.error.message = false
            }

            return validate
        }
    },

    data: function(){

        return{
            sendState: 'normal',
            isactivated: false,
            window: {
            width: 0,
            height: 0
            },
            form: {
                form_departments: [],
                form_country: "",
                data: [],
                data2: [],
                message: ''
            },

            error: {
                form_departments: false,
                form_country: false,
                data: [],
                data2: [],
                message: false
            },


            banner: contactBanner,
            section: '',
            enContent: {
                title: 'CONTACT',
                box: 'Send us your question by completing the following form and selecting the departments you would like to contact'
            },
            esContent: {
                title: 'CONTACTO',
                box: 'Envíenos su pregunta completando el siguiente formulario y seleccionando los departamentos que le gustaría contactar.'
            },

            lenguage: 'ES',
            lenguageEN: {
                error: 'At least select an option',
                error2: 'complete correctly',
                contactText: 'Thank you for contacting us, we will be contacting you in a few minutes. ',
                breadcrumb: {name:'Contact', link:'/en/contact'},
                content1: 'Please select the departments you would like to reach: *',
                content2: [
                    {title: 'Lease - Lease from us', name: 'department'},
                    {title: 'Development - Build with us', name: 'department'},
                    {title: 'Real Estate - Market your properties with us', name: 'department'},
                    {title: 'M&A', name: 'department'},
                    {title: 'Operations & Engineering', name: 'department'},
                    {title: 'Construction & Site / Network Development', name: 'department'},
                    {title: 'Other', name: 'department'},
                ],
                content3: [
                    '* Please, do not use this for press inquiries',
                    '* For requests, complaints and claims for ATP Colombia, it is reported that this is not the ideal means to do so, since this is a commercial contact, so we invite you to refer to the official channel for these purposes.'
                ],
                content4: [
                    {name: 'first_name', placeholder: 'First Name', class:"error-firstname"},
                    {name: 'street_adress', placeholder: 'Street Adress', class:"error-streetAdress"},
                    {name: 'city_adress', placeholder: 'City, State', class:"error-cityAdress"},
                    {name: 'email', placeholder: 'Email', class:"error-emailAdress"}
                ],
                content5: [
                    {name: 'last_name', placeholder: 'Last Name', class:"error-lastName"},
                    {name: 'zip_code', placeholder: 'ZIP Code', class:"error-zipCode"},
                    {name: 'phone', placeholder: 'Phone', class:"error-phone"},
                ],
                contentmovil: [
                    {name: 'first_name', placeholder: 'First Name', class:"error-firstname"},
                    {name: 'last_name', placeholder: 'Last Name', class:"error-lastName"},
                    {name: 'street_adress', placeholder: 'Street Adress', class:"error-streetAdress"},
                    {name: 'city_adress', placeholder: 'City, State', class:"error-cityAdress"},
                    {name: 'email', placeholder: 'Email', class:"error-emailAdress"},
                    {name: 'zip_code', placeholder: 'ZIP Code', class:"error-zipCode"},
                    {name: 'phone', placeholder: 'Phone', class:"error-phone"},
                ],
                content6: {
                    name: 'Country',
                    none: 'Select a country to contact',
                    countries: [
                        'Peru',
                        'Chile',
                        'Colombia',
                        'Ecuador',
                        'USA'
                    ],
                },
                content7: {
                    name: 'message',
                    placeholder: 'Message'
                },
                content8: 'SUBMIT',
                content9: 'Corporate Headquarters:'
            },

            lenguageES: {
                breadcrumb: {name:'Contacto', link:'/es/contacto'},
                content1: 'Por favor seleccione los departamentos a los que le gustaría contactar:',
                error: 'Elija al menos una opcion de las anteriores.',
                error2: 'Complete correctamente.',
                contactText: 'Gracias por contactarnos, nos comunicaremos contigo en unos minutos. ',
                content2: [
                    {title: 'Arrendamiento - Alquile a nosotros', name: 'department'},
                    {title: 'Desarrollo - Construye con nosotros', name: 'department'},
                    {title: 'Bienes Raíces - Comercialice sus propiedades con nosotros', name: 'department'},
                    {title: 'Operaciones & Ingeniería', name: 'department'},
                    {title: 'Desarrollo de Sitios & Redes', name: 'department'},
                    {title: 'Otro', name: 'department'},
                ],
                content3: [
                    '* Para peticiones, quejas y reclamos para ATP Colombia, se informa que este no es el medio idóneo para hacerlo, pues este es un contacto comercial, por lo que les invitamos remitirse al canal oficial para estos fines.'
                ],
                content4: [
                    {name: 'first_name', placeholder: 'Nombre de Pila', class:"error-firstname"},
                    {name: 'street_adress', placeholder: 'Dirección', class:"error-streetAdress"},
                    {name: 'city_adress', placeholder: 'Ciudad, Estado', class:"error-cityAdress"},
                    {name: 'email', placeholder: 'Email', class:"error-emailAdress"}
                ],
                content5: [
                    {name: 'last_name', placeholder: 'Apellido', class:"error-lastName"},
                    {name: 'zip_code', placeholder: 'Código Postal', class:"error-zipCode"},
                    {name: 'phone', placeholder: 'Teléfono', class:"error-phone"},
                ],
                contentmovil: [
                    {name: 'first_name', placeholder: 'Nombre de Pila', class:"error-firstname"},
                    {name: 'last_name', placeholder: 'Apellido', class:"error-lastName"},
                    {name: 'street_adress', placeholder: 'Dirección', class:"error-streetAdress"},
                    {name: 'city_adress', placeholder: 'Ciudad, Estado', class:"error-cityAdress"},
                    {name: 'email', placeholder: 'Email', class:"error-emailAdress"},
                    {name: 'zip_code', placeholder: 'Código Postal', class:"error-zipCode"},
                    {name: 'phone', placeholder: 'Teléfono', class:"error-phone"},
                ],
                content6: {
                    name: 'Country',
                    none: 'Seleccionar un país para contactar',
                    countries: [
                        'Perú',
                        'Chile',
                        'Colombia',
                        'Ecuador',
                        'USA'
                    ],
                },
                content7: {
                    name: 'message',
                    placeholder: 'Mensaje'
                },
                content8: 'ENVIAR',
                content9: 'Sedes corporativas:'
            },
        }
    },
    computed: {
        lenguageSelected: function(){
            return this.$data.lenguage == 'EN'? this.$data.lenguageEN : this.$data.lenguageES
        },
        lenguageNavSelected: function(){
            return this.$data.lenguage == 'EN'? this.$data.enContent : this.$data.esContent
        }
    },
}
</script>

<style lang="scss" scoped>
    .error{
        color: red;
        font-size: 11px;
    }
</style>




// WEBPACK FOOTER //
// src/components/organisms/PmContact.vue